module.exports = __webpack_public_path__ + "img/sieckFinesseSequence2.2f8d5b3b.png";